// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mentions_milestone_ping-cls1__f2a0113b9c840d969899{/*!*/}.mentions_milestone_ping-cls2__fd74a0e633711956ba9e{margin:10px 12px;padding:0;background:none;border:none;color:#0849b8;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "mentions_milestone_ping-cls1__f2a0113b9c840d969899",
	"cls2": "mentions_milestone_ping-cls2__fd74a0e633711956ba9e mentions_milestone_ping-cls1__f2a0113b9c840d969899"
};
export default ___CSS_LOADER_EXPORT___;
